export class LabelsKeys {
	public idWeb = "avis.import.idWeb";
	public codeAcheteur = "avis.import.codeAcheteur";
	public boutonContinuer = "avis.import.continuer";
	public details = "avis.import.avisDetails";
	public id = "avis.import.id";
	public objet = "avis.import.objet";
	public famille = "avis.import.famille";
	public departement = "avis.import.departement";
	public valider = "avis.import.valider";
	public annuler = "avis.import.annuler";
	public refConsultationInfo = "avis.import.refConsultationInfo";
	public refConsultationHelp = "avis.import.refConsultationHelp";
}